// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"b6abce4d","357":"135781ca","615":"c7f7e834","675":"214950f5","762":"37e529ee","787":"908e25f3","982":"bf272954"}[chunkId] + ".chunk.js";
};